module.exports = __webpack_public_path__ + "static/media/guarantee.b15296b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/partners/guarantee.png
// module id = 133
// module chunks = 0